import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, tap } from 'rxjs/operators';

import { UserService } from './users.service';
import { of } from 'rxjs';
import { ToastAlert } from 'projects/access-control/src/app/Infrastructure/hooks/toast.hook';
import {
	deleteUser,
	deleteUserError,
	deleteUserSuccess,
	getUser,
	getUserError,
	getUserSuccess,
	postUser,
	postUserError,
	postUserSuccess,
	searchUser,
	searchUserSuccess,
	updateUser,
	updateUserError,
	updateUserSuccess,
} from './users.actions';
import { TranslateService } from '@mangosoft/mango-layout';
import { searchClientError } from '../clients/clients.action';

@Injectable()
export class UsersEffects {
	dataTranslate: any;
	constructor(
		private actions$: Actions,
		private userService: UserService,
		private toastAlert: ToastAlert,
		private translateService: TranslateService
	) {
		this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslate = data.pages.users.toasts;
		});
	}

	//Users

	getUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getUser),
			concatMap(({ paginationTo }) =>
				this.userService.getUsers(paginationTo).pipe(
					map(({ data, pagination }) =>
						getUserSuccess({
							user: data,
							pagination: pagination,
						})
					),
					catchError((error) => of(getUserError({ error })))
				)
			)
		)
	);

	searchUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(searchUser),
			concatMap(({ url }) =>
				this.userService.searchUsers(url).pipe(
					map(({ data, pagination }) =>
						searchUserSuccess({
							user: data,
							pagination: pagination,
						})
					),
					catchError((error) => of(searchClientError({ error })))
				)
			)
		)
	);

	postUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(postUser),
			concatMap(({ user }) =>
				this.userService.createUsers(user).pipe(
					map(({ data }) => postUserSuccess({ user: data })),
					catchError((error) => of(postUserError({ error })))
				)
			)
		)
	);

	updateUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateUser),
			concatMap(({ user, ids }) =>
				this.userService.updateUsers(user, ids).pipe(
					map(({ data }) => updateUserSuccess({ user: data })),
					catchError((error) => of(updateUserError({ error })))
				)
			)
		)
	);

	deleteUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteUser),
			concatMap(({ user }) =>
				this.userService.bulkDeleteGroup(user).pipe(
					map(({ data }) => deleteUserSuccess({ user: data })),
					catchError((error) => of(deleteUserError({ error })))
				)
			)
		)
	);
	addUsersSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(postUserSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateTitle,
						this.dataTranslate.toastCreateDescription
					);
				})
			),
		{ dispatch: false }
	);

	deleteUsersSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteUserSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteTitle,
						this.dataTranslate.toastDeleteDescription
					);
				})
			),
		{ dispatch: false }
	);
	updateUsersSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateUserSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateTitle,
						this.dataTranslate.toastUpdateDescription
					);
				})
			),
		{ dispatch: false }
	);
	groupsError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteUserError, updateUserError, postUserError, getUserError, searchClientError),
				tap(({ error }) => {
					const msgError = error.error.errorMessage || 'Internal Error ';
					this.toastAlert.toastFailure('Error', msgError);
				})
			),
		{ dispatch: false }
	);
}
